import React, { Component } from 'react';
import { inject } from 'mobx-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './errormessage.scss';

@inject('routerStore')
export default class ErrorMessage extends Component {
    static defaultProps = {
        title: 'Submission not found',
        text: 'We could not find your submission. Please click \'start over\' to begin again.',
        type: 'startover'
    };

    static propTypes = {
        title: PropTypes.string,
        text: PropTypes.string,
        type: PropTypes.oneOf(['startover', 'error'])
    };

    state = {
        closed: false
    };

    onClick = (e) => {
        const { history } = this.props.routerStore;
        history.push({ pathname: '/', state: { transition: 'back' } });
    };

    onClose = (e) => {
        this.setState({ closed: true });
    };

    componentDidMount() {
        const appEl = document.getElementById('heatingtool-app');

        if (!appEl) {
            return;
        }

        window.scrollTo({
            top: appEl.offsetTop,
            left: 0,
            behavior: 'auto'
        });
    }

    render() {
        const { text, title, type } = this.props,
            classes = classNames({
                'ht-errormessage': true,
                'ht-errormessage--overlay': type === 'error',
                'ht-errormessage--closed': this.state.closed
            });

        return <div className={classes}>
            <div className='ht-errormessage-content'>
                {title && (
                    <h2 className='ht-errormessage-title'>{title}</h2>
                )}
                {text && (
                    <p>{text}</p>
                )}
                {type !== 'error' && (
                    <button
                        className='ht-button'
                        type='button'
                        onClick={(e) => this.onClick(e)}
                    >
                        Start over
                    </button>
                )}
                {type === 'error' && (
                    <button
                        className='ht-button'
                        type='button'
                        onClick={(e) => this.onClose(e)}
                    >
                        Close
                    </button>
                )}
            </div>
        </div>;
    }
}
